import {
  UserRole,
  defaultDirection,
  defaultLocale,
  localeOptions,
} from '../constants/defaultValues';

export const getDirection = () => {
  let direction = defaultDirection;

  // try {
  //   if (localStorage.getItem('direction')) {
  //     const localValue = localStorage.getItem('direction');
  //     if (localValue === 'rtl' || localValue === 'ltr') {
  //       direction = localValue;
  //     }
  //   }
  // } catch (error) {
  //   console.log('>>>>: src/helpers/Utils.js : getDirection -> error', error);
  //   direction = defaultDirection;
  // }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};

export const getCurrentLanguage = () => {
  let language = defaultLocale;
  try {
    language =
      localStorage.getItem('currentLanguage') &&
      localeOptions.filter(
        (x) => x.id === localStorage.getItem('currentLanguage')
      ).length > 0
        ? localStorage.getItem('currentLanguage')
        : defaultLocale;
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : getCurrentLanguage -> error',
      error
    );
    language = defaultLocale;
  }
  return language;
};
export const setCurrentLanguage = (locale) => {
  try {
    localStorage.setItem('currentLanguage', locale);
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : setCurrentLanguage -> error',
      error
    );
  }
};

export const getCurrentUser = () => {
  let user = null;
  try {
    user = { email: '123@123.com', role: UserRole.Admin };
    // user =
    //   localStorage.getItem('gogo_current_user') != null
    //     ? JSON.parse(localStorage.getItem('gogo_current_user'))
    //     : null;
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js  : getCurrentUser -> error', error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      // localStorage.setItem('gogo_current_user', JSON.stringify(user));
    } else {
      // localStorage.removeItem('gogo_current_user');
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentUser -> error', error);
  }
};
